<template>
  <div>
    <q-avatar
      v-if="!url && nameShortcut !== 'undefined'"
      :color="$q.dark.isActive ? 'grey-9' : 'grey-4'"
      :size="size"
      rounded
      >{{ nameShortcut }}</q-avatar
    >
    <q-avatar v-else-if="url" :size="size" rounded><img :src="url" :alt="fullName" /></q-avatar>
  </div>
</template>

<script lang="ts" setup>
/*****************************************************************************
 * PROPS
 ****************************************************************************/
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    url?: string;
    fullName?: string;
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | string;
  }>(),
  {
    url: '',
    fullName: '',
    size: 'lg',
  },
);

const nameShortcut = computed(() => {
  return props.fullName.split(' ').reduce((acc, item) => `${acc}${item[0]}`, '');
});
</script>
<style scoped lang="scss">
@import 'styles/app.variables.scss';
:deep(.q-icon) {
  color: white !important;
}
</style>
